<template>
  <div id="cars">
    <div class="content-wrapper">
      <div class="card-wrapper" v-for="(car, index) of cars" :key="index">
        <div class="card">
          <div class="top">
            <img :src="car.photos[0]['medium_thumb']" />
            <div class="view-car" @click="notImplemented">
              <span style="margin-right:8px;">More info</span>
              <font-awesome-icon icon="arrow-right" style="font-size:24px;" />
            </div>
          </div>
          <div class="bot">
            <div
              class="title"
            >{{car.variant['year']}} {{car.variant.make_description}} {{car.variant.family_description}}</div>
            <span class="car-info">
              <font-awesome-icon icon="tachometer-alt" />
              {{car.km | formatNum}} km
            </span>
            <span class="car-info">
              <font-awesome-icon icon="car-side" />
              {{car.variant.body_style}}
            </span>
            <span class="car-info">
              <font-awesome-icon icon="cogs" />
              {{car.variant.transmission_type}}
            </span>

            <div class="flex justify-between" style="margin-top:30px;">
              <h2 class="price">
                <span class="prev">${{car.price + car.savings | formatNum}}</span>
                <span class="curr">${{car.price | formatNum}}</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!cars.length && !loading" class="empty-state flex flex-col align-center">
        <img src="../../assets/img/filters.svg" alt />
        <h1>Could not find any matches related to your search.</h1>
        <span>Please change the filter or reset it below.</span>
        <button @click="resetFilters">Reset filter</button>
      </div>
      <div v-if="!cars.length && loading" class="loading-state flex justify-center">
        <Spinner style="font-size:30px;color:#6030b1" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import Spinner from "../UI/spinner";

export default {
  props: ["cars", "loading"],
  data: () => ({
    response: ""
  }),
  components: {
    Spinner
  },
  methods: {
    resetFilters() {
      this.$emit("resetFilters");
    },
    notImplemented() {
      alert("This feature has not been implemented.");
    }
  }
};
</script>

<style lang="scss" scoped>
#cars {
  padding-top: 40px;
}
.loading-state {
  margin: 80px 0;
  width: 100%;
}
.empty-state {
  padding: 60px 10px 20px 10px;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  img {
    width: 100%;
    max-width: 400px;
  }
  h1 {
    margin: 14px 0;
    font-size: 30px;
    text-align: center;
  }
  span {
    font-size: 20px;
    margin-bottom: 24px;
    color: #6e6e6e;
    text-align: center;
    line-height: 1.5;
  }
  button {
    width: 200px;
    height: 40px;
    background-color: #6030b1;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
    transition: all 200ms ease;
    &:hover {
      background-color: #ff328f;
    }
  }
}
.card-wrapper {
  width: calc(100% / 3);
  display: flex;
  justify-content: center;
  padding: 20px;
  margin-bottom: 20px;
}
.prev {
  margin-right: 12px;
  color: #bfbfbf;
  text-decoration: line-through;
}
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0 -12px;
  background-color: rgba(#f5f7f9, 0.3);
  z-index: 1000;
}
.show-hover {
  max-width: 220px;
  margin: 0 auto;
  cursor: pointer;
  &:hover {
    i {
      transform: translateY(6px) scaleY(1.1);
    }
  }
}

h2 {
  font-size: 30px;
  letter-spacing: -0.05rem;
  font-weight: 700;
  line-height: 1.2;
}

.title {
  display: block !important;
  display: -webkit-box !important;

  //cut off car name if its too long
  -webkit-line-clamp: 1;
  -moz-line-clamp: 1;
  -ms-line-clamp: 1;
  -o-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-box-orient: vertical;
  -o-box-orient: vertical;
  box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  font-weight: 700;
  height: 26px;
  font-size: 24px;
  line-height: 24px;
  color: #6030b1;
  margin-bottom: 24px;
}
.car-info {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  color: #0a1f44;
  margin-bottom: 14px;
  font-weight: 600;
  svg {
    margin-right: 10px;
    font-size: 20px;
    color: grey;
    padding-top: 2px;
  }
}
.top {
  position: relative;
  img {
    width: 100%;
  }
}
.view-car {
  transition: all 350ms ease;
  background-color: rgba(#fff, 0.9);
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  color: #6030b1;
  border-bottom: 2px solid #6030b1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  letter-spacing: -0.05rem;
  font-weight: 700;
  line-height: 1.2;
  transform: translateX(-100%);
  cursor: pointer;
}
.bot {
  padding: 30px 5px 30px 20px;
}
.card {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(#6030b1, 0.4);
  transition: 0.3s ease-out;
  position: relative;
  left: 0px;
  &:hover {
    transition: 0.3s ease-out;
    transform: translateY(-10px);
    .view-car {
      transform: translateX(0%);
    }
  }
}
.price {
  float: right;
  margin-right: 6px;
  color: #6030b1;
  font-size: 22px;
}
@media (max-width: 1000px) {
  .card-wrapper {
    width: 50%;
  }
}
@media (max-width: 680px) {
  .card-wrapper {
    padding: 0;
    width: 100%;
    margin-bottom: 60px;
  }
}
</style>